import { TranslationsObject } from "@genericTypes/sharedTypes";
import { translate } from "@helpers/translationObjectFormatter";
import { useForm } from "@severalbrands/form-fusion";
import { useQuery } from "@tanstack/react-query";
import React from "react";

const CloseModal = () => {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    const { toggleModal, setStep } = useForm();

    return (
        <p
            className="text-[#ffffff64] text-[16px] font-normal underline z-10"
            onClick={() => {
                toggleModal({ show: false });
                setStep({ step: 0 });
            }}
        >
            {translate(
                translations,
                "several_general_formModalBackPreviousPage",
            )}
        </p>
    );
};

export default CloseModal;
